import { useState } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../api/client';
import { useAppInfo } from '../context/AppContext';
import { useSite } from '../context/SiteContext';
import './AuthPage.css';

type Status = 'idle' | 'submitting' | 'sent';

export default function ForgotPasswordPage() {
  const { logoUrl: appLogoUrl } = useAppInfo();
  const { site } = useSite();
  const logoUrl = site?.logoUrl ?? appLogoUrl;

  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<Status>('idle');
  const [error, setError] = useState('');

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setStatus('submitting');
    try {
      await apiClient.post('/PasswordRecovery/send-reset', { email });
      setStatus('sent');
    } catch {
      setError('Something went wrong. Please try again.');
      setStatus('idle');
    }
  }

  if (status === 'sent') {
    return (
      <div className="auth-page">
        {logoUrl && <img src={logoUrl} alt="Logo" className="auth-page-logo" />}
        <div className="auth-card">
          <h1 className="auth-title">Check Your Email</h1>
          <p style={{ textAlign: 'center', color: 'rgba(255,255,255,0.7)', lineHeight: 1.6 }}>
            If an account exists for <strong>{email}</strong>, you will receive a password reset link shortly.
            The link expires in 24 hours.
          </p>
          <p className="auth-footer">
            <Link to="/login">Back to sign in</Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      {logoUrl && <img src={logoUrl} alt="Logo" className="auth-page-logo" />}
      <div className="auth-card">
        <h1 className="auth-title">Reset Password</h1>
        <p style={{ textAlign: 'center', color: 'rgba(255,255,255,0.6)', marginBottom: '1.25rem', fontSize: '0.9rem' }}>
          Enter your email and we&apos;ll send you a reset link.
        </p>
        <form onSubmit={handleSubmit} className="auth-form">
          <label className="auth-label">
            Email
            <input
              className="auth-input"
              type="email"
              autoComplete="email"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck={false}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
          {error && <p className="auth-error">{error}</p>}
          <button className="auth-btn" type="submit" disabled={status === 'submitting'}>
            {status === 'submitting' ? 'Sending…' : 'Send Reset Link'}
          </button>
        </form>
        <p className="auth-footer">
          <Link to="/login">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
